import updateMenuDropdowns from "./components/updateNavDropdowns";
import { initEventsSlider, initGalleriesSlider } from "./components/sliders";
import {
  initAnimNewsCircle,
  initAnimFrontCircle,
  initAnimNewsPageCircle,
  initAnimNewsPageTitle,
  initAnimNewsItems,
  initAnimCalendarHeader,
  initAnimTitle,
} from "./components/animations";
import { newsLoaded, addBodyClass } from "./components/facetwp";
import initEventsCalendar from "./components/fullcalendar";
import initImageModals from "./components/imageModals";
import {
  initCircleMovement,
  initRedCircleMovement,
} from "./components/roundAnimations";
import initCookie from "./components/cookie";
import initKeyboardNav from "./components/keyboardnav";

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");

      const searchBtn = document.querySelector(".mobile-search-button");
      const searchMenu = document.querySelector(".mobile-search-menu");

      if (searchBtn.classList.contains("is-active")) {
        searchBtn.classList.remove("is-active");
        searchMenu.classList.remove("is-open");
      }
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

function openSearchMenu() {
  function init() {
    const btn = document.querySelector(".mobile-search-button");
    const menu = document.querySelector(".mobile-search-menu");

    btn.addEventListener("click", () => {
      btn.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");

      const hamburger = document.querySelector(".hamburger");
      const mobileMenu = document.querySelector(".mobile-menu");

      if (hamburger.classList.contains("is-active")) {
        hamburger.classList.remove("is-active");
        mobileMenu.classList.remove("is-open");
      }
    });
  }

  const isPresent = document.getElementsByClassName("mobile-search-button");
  if (isPresent.length > 0) {
    init();
  }
}

function animateInMaxHeight(element) {
  function removeMaxHeight() {
    this.style.maxHeight = "none";
    this.removeEventListener("transitionend", transitionEndCallback);
    delete element._transitionEnd;
  }

  let transitionEndCallback = removeMaxHeight.bind(element);
  element._transitionEnd = transitionEndCallback;

  element.style.maxHeight = `${element.scrollHeight}px`;
  element.addEventListener("transitionend", transitionEndCallback);
}

function animateOutMaxHeight(element) {
  element.style.maxHeight = `${element.scrollHeight}px`;
  element.offsetHeight;

  if (element._transitionEnd) {
    element.removeEventListener("transitionend", element._transitionEnd);
  }

  setTimeout(function () {
    element.style.maxHeight = "0px";
  }, 1);
}

function openSubMenu() {
  const toggleTriggers = document.querySelectorAll(
    `.primary-nav-mobile .menu-item-has-children > a`
  );
  toggleTriggers.forEach((trigger) => {
    let toggle = trigger.nextElementSibling;

    toggle.classList.add("overflow-hidden");
    toggle.style.transition = `max-height 400ms`;

    function openItem() {
      trigger.classList.add("open");
      trigger.parentElement.classList.add("open");

      animateInMaxHeight(toggle);
    }

    function closeItem() {
      trigger.classList.remove("open");

      setTimeout(() => {
        trigger.parentElement.classList.remove("open");
      }, 300);

      animateOutMaxHeight(toggle);
    }

    trigger.addEventListener(
      "click",
      (e) => {
        e.preventDefault();

        if (trigger.classList.contains("open")) {
          closeItem();
        } else {
          openItem();
        }
      },
      false
    );
  });
}

function runOnLoadAndDocumentReady() {
  setTimeout(() => {
    updateMenuDropdowns();
  }, 10);

  initEventsSlider();
  initGalleriesSlider();

  initAnimNewsCircle();
  initAnimFrontCircle();
  initAnimNewsPageCircle();
  initAnimNewsPageTitle();
  initAnimNewsItems();
  initAnimTitle();

  setTimeout(() => {
    initAnimCalendarHeader();
  }, 0);

  newsLoaded();
  addBodyClass();

  initEventsCalendar();

  openMenu();
  openSubMenu();
  openSearchMenu();
  initImageModals();

  initCircleMovement();
  initRedCircleMovement();
  initCookie();
  initKeyboardNav();

  document.body.classList.add("js-animate-in");
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}
